import React, { useState, useEffect } from 'react';
import './Payload.scss';
import Team from "./Team/Team";
import DecisionCircles from '../../partials/DecisionCircles'
import PayloadReview from './PayloadReview';
import Simulation from './Simulation';
import Questions from './Questions/Questions';
import Modal from "../../partials/Modal/SimpleModal/SimpleModal"
import Footer from "../../partials/Footer"
import Kpis, { kpiUpdate } from "../../partials/Kpis"
import Media from "../../partials/Media"
import HiddenPanel from "../../partials/HiddenPanel"
import Button from '../../partials/Button';
import ButtonsHolder from '../../partials/Button/ButtonsHolder';
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import useTeam from './common/hooks/useTeam'
import TeamFeedback from './Team/TeamFeedback/TeamFeedback';
import PayloadParts from './PayloadParts'
import Header from '../../partials/Header';
import Scroll from '../../partials/Scroll/Scroll';
import axios from "axios";

const Payload =  ({ goBackToPreviousSegment, breadcrumbs, data, onComplete, globals }) => {
    const { categories, questions, mission, team, review, downloadButtonCaption = 'PAYLOAD TOOL', downloadFile = 'NOVA_Space_SSAT.xlsx' } = data || []
    const { members, currentSpeech } = useTeam(data.team || {})

    const [viewPort, setViewPort] = useState('Decisions');
    const [answersFeedback, showAnswersFeedback] = useState();
    const [showFeedback, setShowFeedback] = useState();

    const [completedQuestions, setCompletedQuestions] = useState();
    const [categorySelection, setCategorySelection] = useState();
    const [showFormulas, setShowFormulas] = useState();
    const [categoriesData, setCategoriesData] = useState();
    const [memberFeedback, setMemberFeedback] = useState()
    const [nextQuestion, setNextQuestion] = useState(0)


    const [kpis, setKpis ] = useState(() => {
        return data.kpis_initial_values || {}
    })
    const markers = data.markers || []

    const [paintParts, setPaintParts] = useState([])
    const [choicesCompleted, setChoicesCompleted] =  useState(true)

    useEffect(() => {
        setChoicesCompleted(paintParts.length === categories.length)
    }, [paintParts])


    useEffect(()=> {
        if(!categoriesData) setCategoriesData(categories)
    },[])

    const completeCategories = () => handleGoToView('PayloadReview')
    const completeReview = () => handleGoToView('Questions')

    const handleAnswers = (feedback) => {
        const allCorrect = feedback.answers.every((itm) => itm.correct) ? true : false
        const someCorrect = feedback.answers.some((itm) => itm.correct) ? true : false
        const allWrong = !allCorrect && !someCorrect

        showAnswersFeedback(feedback)
        setShowFeedback({
            status: allWrong ? 'failed' : allCorrect ? 'success' : 'warning',
            caption: allWrong ? 'Failed' : allCorrect ? 'This Could Work' : 'It Might Work',
        })

    }

    const handleModalClose = () => {
        setShowFeedback(false)
        setCategorySelection()
    }

    const handleCategoryCallback = (result) => {
        setCategorySelection(result)
    }
    const handleCategorySelection = () => {
    }
    const handleGoToView = (view) => {
        setViewPort(view)
    }


    /**
     * Handles Deploy Button Actions
     * @param {*} selection
     */
    const handleDeploy = (selection) => {

        const deployed = deployDecision(categoriesData, selection)
        const parts = partsUpdate(deployed)

        setCategoriesData(deployed)
        setPaintParts(parts)
        setKpis(kpiUpdate(kpis, selection.answer.kpis))
        handleModalClose()
        //

    }

    const handleFormulas =()=>{
        setShowFormulas(showFormulas ? false : true)
    }

    const handleDownload = () => {
        download(`docs/${downloadFile}`, downloadFile )
    }

    const partsUpdate = (cats) => {
        const parts = cats.filter((cat) => cat.done )//.map((cat)=>cat.part)
        console.log(parts)
        return parts

    }

    const deployDecision = (cats, deployedSelection) => {

        const category = cats.find(cat => cat.id === deployedSelection.id)

        const selected = category.decisions.map((des) => {

            return ({
                ...des,
                choosed:(
                    (des.name === deployedSelection.decisions.name  && !deployedSelection.answer.choosed) ||
                    des.choosed && des.name !== deployedSelection.decisions.name
                ),
                decisions: des.decisions.map((answ) => {
                    return ({
                        ...answ,
                        choosed: (answ.answer ===  deployedSelection.answer.answer && !deployedSelection.answer.choosed) ||
                        ( answ.choosed && des.name !== deployedSelection.decisions.name )

                    })
                })
            })
        })

        const newDeployedDecisions = cats.map((cat) =>  (
            cat.id === deployedSelection.id ?
                {
                    ...cat,
                    decisions: selected,
                    done: selected.every((itm) => itm.choosed)

                } : cat
        ))

        return newDeployedDecisions

    }

    const handleTeamCallback = (member) => {
        setMemberFeedback(member)
    }

    const HeaderButtons = () => {
        return (
            <Button
                text={downloadButtonCaption}
                variant='fit-height'
                onClick={handleDownload} />
        )
    }

    const handleBackButton = () =>{

        if(viewPort === 'Decisions') goBackToPreviousSegment()
        if(viewPort === 'PayloadReview') handleGoToView('Decisions')
        if(viewPort === 'Questions') handleGoToView('PayloadReview')

    }

    return (
        <InteractionContainer breadcrumbs={breadcrumbs} >
            <div className="payload-container">
                <Header
                    title='Payload'
                    intro={data.instructions}
                    backButtonHandler={handleBackButton}
                    buttons={ HeaderButtons() }
                />
                { viewPort === 'Decisions' && <>
                    <div className="payload-body">
                        <div className="left-panel">

                            {categoriesData && <DecisionCircles
                                categories={categoriesData}
                                onSelectHandle={handleCategorySelection}
                                callback={handleCategoryCallback} />
                            }

                        </div>
                        <div className="right-panel" >


                            <PayloadParts
                                allParts={categories}
                                parts={paintParts}
                                deployed={categoriesData}
                                button={ {
                                    text: data?.config?.confirmBuildButton || 'Confirm Build',
                                    disabled: !choicesCompleted,
                                    onClick: completeCategories
                                }}
                            />

                        </div>
                    </div>

                </>}
                { viewPort === 'PayloadReview' &&
                    <PayloadReview
                        data={categoriesData}
                        kpiFeedback={{markers, kpis}}
                        instructions={review ? review.instructions : ' Your payload is set! Now, select Run Simulation to see how the satellite will perform with these components'}
                        config={data?.config}
                        onBack={handleGoToView}
                        onComplete={completeReview} />
                }

                { viewPort === 'Questions' &&
                    <div className="questions-container">
                        <div>
                            <Questions data={data}
                                feedback={handleAnswers}
                                globals={globals}
                                next={nextQuestion}
                                onComplete={ () => setCompletedQuestions(true) }
                                navigate={false}
                            />
                        </div>
                        <div >

                            <PayloadParts
                                allParts={categories}
                                parts={paintParts}  >
                            </PayloadParts>
                            <ButtonsHolder variant="fixed-bottom" orientation="right">
                                <Button
                                    text={ data?.config?.questionnaireNextButton || "Next" }
                                    onClick={onComplete}
                                    disabled={!completedQuestions}
                                />
                            </ButtonsHolder>
                        </div>
                    </div>
                }
                { viewPort === 'Finished' && <h2>Its Done</h2>}

                {/* This will be used on V2, don't remove it please */}
                {/* {(viewPort === 'PayloadReview' || viewPort === 'Decisions') && <>
                    <Footer>
                        <Kpis kpis={kpis} markers={markers} />
                    </Footer>
                    <HiddenPanel button="Ask the team" >
                    <Team
                        members={members}
                        speak={currentSpeech}
                        callback={handleTeamCallback}
                    />
                </HiddenPanel>
                 </>} */}


                 { categorySelection &&
                        <Modal
                            size="small"
                            header={categorySelection.decisions.name}
                            show={true}
                        >
                            <div className='modal-category-selection'>
                                {/* <div className='modal-cat-media'>
                                    <Media
                                        type={'image'}
                                        src={categorySelection.img}
                                    />
                                </div> */}
                                <div className="modal-cat-desc">
                                    <h3>{categorySelection.answer.answer}</h3>
                                    <p>{categorySelection.answer.desc}</p>
                                    {/* Commented for version 2.*/}
                                    {/*<ul>*/}
                                    {/*    {*/}
                                    {/*        categorySelection.answer.kpis.map((kpi) => (*/}
                                    {/*            <li key={kpi.title}>*/}
                                    {/*                <span>{kpi.title}</span>*/}
                                    {/*                {kpi.value}*/}
                                    {/*            </li>*/}
                                    {/*        ))*/}
                                    {/*    }*/}
                                    {/*</ul>*/}

                                    <ButtonsHolder variant="single" orientation="right" >
                                        <Button
                                            text={categorySelection.answer.choosed ? 'Undeploy' : 'Deploy'}
                                            className="small primary"
                                            onClick={() => handleDeploy(categorySelection)}
                                        />

                                        <Button
                                            text="close"
                                            onClick={handleModalClose}
                                        />
                                    </ButtonsHolder>
                                </div>
                            </div>
                        </Modal>
                    }
                    { showFormulas &&
                        <Modal
                            size="small"
                            header="Formulas"
                            show={true}
                            html={ data.formulas }
                            onClose={ handleFormulas } >
                        </Modal>
                    }
                    { memberFeedback &&
                        <Modal
                            size="small"
                            show={memberFeedback}
                            onClose={ () => setMemberFeedback() } >

                                <TeamFeedback member={memberFeedback} />
                        </Modal>
                    }

            </div>
        </InteractionContainer>
    );

}

function download(url, fileName) {
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
    })
        .then((response) => {
            const url = window.URL
                .createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(e  => {
            console.error(e.message);
            alert('Unable to download file');
        })
}

export default Payload;
